
import DatePicker from '@/components/Atomic/DatePicker.vue'
const Props = Vue.extend({
  props: {
    onClose: Function,
  },
})

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserMIREO from '../../models/userMireo'
import Establishment from '@/models/establishment'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
// Used for notifications.
import { INotificationService } from '../../services/NotificationService'
import UserMireoService from '@/services/UserMireoService'
import ErrorHandler from '@/services/ErrorHandlerService'
import moment from 'moment'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    ProgressLinear,
    DatePicker,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class StartMission extends Props {
  @Prop() public readonly schools: Establishment[] | undefined
  private dialog: boolean = false
  private isPending: boolean = false
  private selectedEstablishmentId: string = ''

  private account: any = {} as UserMIREO

  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService

  public show(account: any) {
    this.$validator.reset()
    this.dialog = true
    this.account = account
    const today = moment(new Date()).format('YYYY-MM-DD')
    const validity_date = moment(this.account.date_validite)
    if (
      validity_date.isBefore(today) ||
      validity_date.format('YYYY-MM-DD') === '2199-07-31'
    ) {
      this.account.date_validite = moment(new Date()).format('YYYY-MM-DD')
    }
  }

  private hide() {
    this.$validator.reset()
    this.onClose()
    this.account = {}
    this.selectedEstablishmentId = ''
    this.dialog = false
  }

  private async validate() {
    const validated = await this.$validator.validateAll()
    if (validated) {
      this.start()
    }
  }

  private async start() {
    this.isPending = true
    try {
      const response = await UserMireoService.startMission(
        this.account.ad_personne_id,
        this.account.date_validite,
        this.account.identifiant,
        this.selectedEstablishmentId,
      )
      this.$notificationService.success(
        this.$t('MIREOACCOUNT.StartMissionSuccessMessage').toString(),
      )
      this.account.date_validite = response
      this.hide()
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
    this.isPending = false
  }
}
